import CrudBaseService from "@/services/CrudBaseService";

export default class ProductService extends CrudBaseService {
  constructor() {
    super('contract/product');
  }

  findAllByParams(data) {
    return this.http.get(`${this._serviceName}/findAllByParams`, { params: data });
  }

  findById(id) {
    return this.http.get(`${this._serviceName}/${id}`);
  }

  findSuperAccreditedNetworkById(id) {
    return this.http.get(`${this._serviceName}/${id}/superAccreditedNetwork`);
  }

  findByIdView(id) {
    return this.http.get(`${this._serviceName}/${id}/view`);
  }

  findByCarrier(carrierId) {
    return this.http.get(`${this._serviceName}/findByCarrier`, { params: {carrierId} });
  }
}